import React from "react";

import { Tooltip } from "@material-ui/core";
import RejectedIcon from "@material-ui/icons/HighlightOff";
import { red } from "@material-ui/core/colors";

import { RemoveIcon } from "../../../components/common/iconography";
import { OutboundStatus } from "../../../utils/constants";

export const AdviceStatusIcon = ({ record, ...props }) => {
  if (!record) return null;
  else
    return record.status === OutboundStatus.ADVICE_REJECTED ? (
      <Tooltip title="Rejected" placement="right" arrow>
        <RejectedIcon style={{ color: red[700] }} />
      </Tooltip>
    ) : (
      <Tooltip title="Pending Review" placement="right" arrow>
        <RemoveIcon color="disabled" />
      </Tooltip>
    );
};
